import { Controller } from 'stimulus'

// Submits its form when an input changes, e.g. an on/off switch:
//   <form data-controller="auto-submit"><input data-action="auto-submit#submit">
export default class extends Controller {
  submit() {
    this.element.requestSubmit ? this.element.requestSubmit() : this.element.submit()
  }
}
